import { RecapitoVO } from "./recapitoVO";
import { TipoSoggettoAnagrafeEnum } from "@app/shared/enum/tipo-soggetto-anagrafe-enum";
import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";
import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";

export class DestinatarioVO {
  tipoDestinatario: TipoDestinatarioEnum = TipoDestinatarioEnum.DIRETTO;
  tipoSoggetto: TipoSoggettoAnagrafeEnum;
  recapitoVO: RecapitoVO = new RecapitoVO();
  invio: boolean;
}
